import React from "react";
import { Translate } from "components/common/Translate/Translate"; // import { CompareImageComponent } from "components/features/JpegCompressor/CompareImageComponent";
import dynamic from "next/dynamic";
import { humanFileSizeFromKb } from "@/utils/humanFileSize";

interface ICompareOriginalVsCompressedProps {
    imageSrc1: string;
    imageSrc2: string;
    originalSizeInKb: number;
    compressedSizeInKb: number;
}

const CompareImageComponent = dynamic<{
    imageSrc1: string;
    imageSrc2: string;
}>(
    () => import("components/features/CompressorCommon/CompareImageComponent").then((mod) => mod.CompareImageComponent),
    {
        ssr: false,
    },
);
const CompareOriginalVsCompressed = (props: ICompareOriginalVsCompressedProps) => {
    const originalFileSizeString = humanFileSizeFromKb(props.originalSizeInKb, true);
    const compressedFileSizeString = humanFileSizeFromKb(props.compressedSizeInKb, true);
    const reducedInPercent = Math.round((1 - props.compressedSizeInKb / props.originalSizeInKb) * 100);

    return (
        <div className=" flex justify-center items-center-center content-center w-full pb-10 border-b-2">
            <div className="w-full max-w-4xl">
                <h2 className="text-24 font-semibold text-center dark:text-white">
                    <Translate keyName="compare-original-vs-compressed-title" />
                </h2>
                <h3 className="text-center dark:text-white">
                    <Translate keyName="compare-original-vs-compressed-subtitle" />
                </h3>

                <div className="flex flex-row gap-[1px] h-12  content-evenly mb:mt-[64px] mt-[72px] ">
                    <div className="text-center text-xs sm:text-sm md:text-base px-2  bg-gray-200 dark:bg-gray-700 dark:text-white flex-grow w-full flex justify-center items-center rounded-sm">
                        <p>
                            <span>
                                <Translate keyName="original" />
                            </span>
                            <span>{":"} </span>
                            <span className="font-semibold">{originalFileSizeString}</span>
                        </p>
                    </div>
                    <div className="text-xs sm:text-sm text-center md:text-base px-1 sm:px-2  bg-gray-200 dark:bg-gray-700 dark:text-white flex-grow w-full flex justify-center items-center rounded-sm flex-wrap ">
                        <p>
                            <span>
                                <span>
                                    <Translate keyName="compressed" />
                                </span>
                                <span>{":"} </span>
                            </span>
                            <span className="font-semibold">
                                {`${compressedFileSizeString}`} (-{reducedInPercent}%)
                            </span>
                        </p>
                    </div>
                </div>

                <div className="mt-5 w-full  aspect-[840/440]">
                    <CompareImageComponent imageSrc1={props.imageSrc1} imageSrc2={props.imageSrc2} />
                </div>
                <p className="mt-10 font-bold text-center dark:text-white">
                    <Translate keyName="impressive-compression-results" />
                </p>
                <p className="mt-2 dark:text-white text-center">
                    <Translate keyName="our-compressor-uses-lossy-compression" />
                </p>
            </div>
        </div>
    );
};

export default CompareOriginalVsCompressed;
